<script>
import {api} from "@/modules/api";

export default {
  name: 'LineUserByMonth',
  props: {
    width: Number
  },
  data () {
    return {
      charts: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      api.kpis.getStatsUsersByMonth().then((res) => {
        this.charts = res
      })
    }
  }
}
</script>

<template>
  <div v-if="charts.options" :id="charts.options.chart.id">
    <apexchart type="line" :width="width" :options="charts.options" :series="charts.series"></apexchart>
  </div>
</template>
